import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import _ from 'lodash';

// 依存スタイル
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { getScreenWidth, generateKey } from '@/utils';
import Placeholder from '@/components/Placeholder';
import {
  Wrapper,
  ItemsWrapper,
  Title,
  ItemsNames,
  ItemsNameLineWrapper,
  ItemsNameWrapper,
  ItemsName,
  ItemsLine,
  Hr,
  // スライダー1段バージョン
  SliderWrapper,
  // スライダー2段バージョン
  SliderSyncingWrapper1,
  SliderSyncingWrapper2,
  CoverLeft,
  CoverRight,
} from '@/components/Slider/Slick.style';
import { TABLET_P } from '@/constants';

/**
 * スライダー
 *   * 選択したアイテムをスライダーの中央に配置させたい場合に使用する
 */
class Slick extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      // 2段スライダー上下に使用する
      nav1: null,
      nav2: null,
      // バリエーションがある場合、選択した ID をキャッシュさせるのに使用する
      selectedId: 0,
      // ブラウザ伸縮時に更新されたスクリーンサイズ (スタイル用)
      syncingScreenSize: null,
    };
  }

  componentDidMount() {
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2,
    });

    // ブラウザの横幅をマウスなどによる伸縮に追随させた時に、スクリーンサイズが適切に更新されない場合があるため、リサイズイベントを走らせる
    window.addEventListener('resize', () => this.setState({ syncingScreenSize: getScreenWidth() }));
  }

  render() {
    const {
      withVariation,
      variation,
      children,
      withTitle,
      title,
      shouldSync,
      screenSize,
      dimension,
      options,
    } = this.props;
    const { nav1, nav2, selectedId, syncingScreenSize } = this.state;

    // スライダー共通設定
    const settings = {
      // スライドループ
      infinite: true,
      // スライド速度
      speed: 500,
      // ページング数
      slidesToScroll: 1,
      // 要素を中央に配置
      centerMode: true,
    };

    return (
      <Wrapper>
        {!!(withTitle || withVariation) && (
          <ItemsWrapper>
            {withTitle && (
              <React.Fragment>
                <Title>{title || <Placeholder w="150px" h="20px" />}</Title>
                <Hr />
              </React.Fragment>
            )}
            {withVariation && (
              <ItemsNames>
                {!(variation && variation.length > 0 && _.find(variation, item => _.get(item, 'name'))) ? (
                  <Placeholder w="100%" h="50px" />
                ) : (
                  <React.Fragment>
                    {variation.map((product, productIndex) => (
                      <ItemsNameLineWrapper key={generateKey('product-used', productIndex)}>
                        <ItemsNameWrapper
                          // クロージャにしておく
                          onClick={() => {
                            this.setState({ selectedId: productIndex });
                            this.slider.slickGoTo(productIndex);
                          }}
                          background={product.colorCode}
                        >
                          {product.name ? <ItemsName>{product.name}</ItemsName> : <Placeholder w="100%" h="50px" />}
                        </ItemsNameWrapper>
                        {productIndex === selectedId && <ItemsLine />}
                      </ItemsNameLineWrapper>
                    ))}
                  </React.Fragment>
                )}
              </ItemsNames>
            )}
          </ItemsWrapper>
        )}
        {!shouldSync ? (
          <SliderWrapper>
            <CoverLeft />
            <Slider
              {...settings}
              beforeChange={(current, next) => this.setState({ selectedId: next })}
              {...options}
              ref={slider => (this.slider = slider)}
            >
              {children}
            </Slider>
            <CoverRight />
          </SliderWrapper>
        ) : (
          <React.Fragment>
            <SliderSyncingWrapper1 screenSize={syncingScreenSize || screenSize} height={dimension.sliderWrapper.height}>
              <Slider
                {...settings}
                variableWidth
                dots={false}
                arrows
                asNavFor={nav2}
                ref={slider => (this.slider1 = slider)}
              >
                {_.get(children[0], 'props.children')}
              </Slider>
            </SliderSyncingWrapper1>
            <SliderSyncingWrapper2
              screenSize={syncingScreenSize || screenSize}
              slickSlideWidth={screenSize > TABLET_P ? children[1].length * 100 - 5 : children[1].length * 60}
              itemLength={children[1].length}
            >
              <Slider {...settings} {...options} focusOnSelect asNavFor={nav1} ref={slider => (this.slider2 = slider)}>
                {children[1]}
              </Slider>
            </SliderSyncingWrapper2>
          </React.Fragment>
        )}
      </Wrapper>
    );
  }
}

Slick.defaultProps = {
  withTitle: false,
  title: null,
  withVariation: false,
  variation: null,
  shouldSync: false,
  screenSize: null,
  dimension: {
    sliderWrapper: {
      width: null,
      height: null,
      slickSlideWidth: null,
      slickSlideHeight: null,
    },
  },
  options: {},
};

Slick.propTypes = {
  // スライダー内のノード
  children: PropTypes.node.isRequired,
  // タイトルを表示させるかどうかを真偽で受ける
  withTitle: PropTypes.bool,
  // タイトル
  title: PropTypes.string,
  // バリエーションを表示させるかどうかを真偽で受ける
  withVariation: PropTypes.bool,
  // バリエーション (例) STYLE PAGE のカラーバリエーション)
  variation: PropTypes.arrayOf(PropTypes.shape({})),
  // 2段スライダー上下で選択情報を同期させるかどうかを真偽で受ける
  shouldSync: PropTypes.bool,
  // スクリーンサイズ
  screenSize: PropTypes.number,
  // スライダーサイズ
  dimension: PropTypes.shape({}),
  // スライダー設定
  options: PropTypes.shape({}),
};

const mapState = () => ({
  // スクリーンサイズを実寸で取得する
  screenSize: getScreenWidth(),
});

export default connect(mapState)(Slick);



// WEBPACK FOOTER //
// ./src/components/Slider/Slick.js